export default __webpack_public_path__ + "static/media/dai.75fa6063.svg";